/**
 * Predefined tags configuration by product.
 *
 * These tags are shown as suggestions in the UI but are stored
 * the same way as custom tags (no separate database storage).
 */

import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';

const eiPredefinedTags = ['engagement', 'compare', 'experience', 'performance', 'report', 'errors'];

const appPredefinedTags = [
  'engagement',
  'compare',
  'experience',
  'performance',
  'report',
  'errors',
];

export const PREDEFINED_TAGS =
  {
    EI: eiPredefinedTags,
    APP: appPredefinedTags,
  }[CURRENT_PRODUCT_MODE] || [];
